import { Star } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { motion } from "framer-motion";
import { RatingDialog } from "./RatingDialog";
import { useState } from "react";

export default function RateButton({ profileData }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative flex items-center">
      <motion.button
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="fixed bottom-5 right-5 w-10 h-10 bg-yellow-500/50 text-white rounded-full shadow-lg flex items-center justify-center gap-2"
        onClick={() => {
          if (user) {
            setOpen(true);
          } else {
            alert("Please login to rate this user.");
          }
        }}
      >
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-yellow-500 opacity-75" />
        <Star fill="#eab308" color="#eab308" className="size-5" />
      </motion.button>

      <RatingDialog
        type={"user"}
        id={+profileData.user_id?.id || +profileData.user.id}
        open={open}
        onOpenChange={setOpen}
        apiUrl={`/reviews/user/${
          +profileData.user_id?.id || +profileData.user.id
        }`}
        title={`Rate your ${
          profileData.user_id?.name || profileData.user?.name
        }`}
        description={`How would you rate your ${
          profileData.user_id?.name || profileData.user?.name
        } with us?`}
      />
    </div>
  );
}
